// extracted by mini-css-extract-plugin
export default {"wrapper":"cLQg4","content":"atAqB","header":"weSMx","button":"q6y7R","inputs":"ejM6C","payments":"IXgzO","container":"ZDSbO","inputs-container":"poTkv","button-container":"fQeBT"};